import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {
    convertPersianDateToUniversalDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomTable,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";
import {useAuthState} from "../../context/AuthContext";
import {stringIsEmpty} from "../../util/VariableChecker";
import {LogsService} from "../../service/logs/LogsService";

export default function SystemLogsList() {

    const {fundID} = useAuthState()

    const [totalItems, setTotalItems] = useState(0)
    const [logs, setLogs] = useState([])
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0)

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1)
    const size = 20

    const navigate = useNavigate()

    const [actionTypes, setActionTypes] = useState(searchParam.get("action-type") || "ALL")
    const [category, setCategory] = useState(searchParam.get("category") || "ALL")
    const [startDate, setStartDate] = useState(searchParam.get("start-date") || "")
    const [endDate, setEndDate] = useState(searchParam.get("end-date") || "")


    const filterActionType = useDebounce(actionTypes, 300)
    const filterCategory = useDebounce(category, 300)
    const filterStartDate = useDebounce(startDate, 300)
    const filterEndDate = useDebounce(endDate, 300)


    const service = new LogsService()

    useEffect(() => {
        getLogsFromServer()
    }, [
        fundID,
        page,
        filterActionType,
        filterCategory,
        filterStartDate,
        filterEndDate,
    ]);


    function prepareItem(id, number, submittedAt, doBy, entityType, action) {
        return {
            id: id,
            number: number,

            type: action,
            category: entityType,
            date: submittedAt,
            username: doBy,
        }
    }

    function getLogsFromServer() {

        setTableLoading(true)
        service.getLogs(
            fundID,
            page - 1,
            size,
            filterActionType !== "ALL" ? filterActionType : "",
            filterCategory !== "ALL" ? filterCategory : "",
            filterStartDate ? convertPersianDateToUniversalDate(filterStartDate) : "",
            filterEndDate ? convertPersianDateToUniversalDate(filterEndDate) : ""
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)
            setLogs([])
            response.data.map((item, index) => {
                setLogs(prevState => [
                    ...prevState,
                    prepareItem(
                        item.id,
                        (page * size) + index + 1,
                        item.submittedAt,
                        item.doBy,
                        item.entityType,
                        item.action
                    )
                ])
            })

            if (response.data.length === 0)
                showWarningMessage("در حال توسعه این بخش هستیم. به زودی در دسترس خواهد بود.")

        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {
            setTableLoading(false)
        })
    }

    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }

    function handleShowDetail(id) {
        let title = ""

        logs.map((item) => {
            if (item.id === id) {
                title = item.category
            }
        })

        navigate(
            RouteHelper.LogsDetail.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )
    }

    function handleDeleteAllFilters() {
        setCategory("ALL")
        setActionTypes("ALL")
        setStartDate("")
        setEndDate("")
    }


    return <>
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(RouteHelper.LogsList.name, ""),
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"آخرین لاگ هــا"}
                            amount={totalItems}
                        />

                        <RaikoTableSearchContainer
                            hasFilter={true}
                            hasSearchInput={false}
                            labelText={"نام و نام خانوادگی"}
                            placeHolder={"عبارت مورد نظر را وارد نمایید"}
                            // setValue={setFullName}
                            // value={fullName}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                !stringIsEmpty(filterStartDate) ||
                                !stringIsEmpty(filterEndDate) ||
                                filterCategory !== "ALL" ||
                                filterActionType !== "ALL"
                            }
                        >
                            <RaikoGridOneColumn>

                                <RaikoCustomSelect
                                    labelText={"عملیات"}
                                    value={actionTypes}
                                    setValue={setActionTypes}
                                    items={[
                                        raikoCustomSelectItemGenerator(
                                            "ALL", "همه"
                                        ),
                                        raikoCustomSelectItemGenerator(
                                            "delete", "پاک کردن"
                                        ), raikoCustomSelectItemGenerator(
                                            "create", "افزودن"
                                        ), raikoCustomSelectItemGenerator(
                                            "edit", "ویرایش"
                                        )
                                    ]}
                                />

                                <RaikoCustomSelect
                                    labelText={"دسته بندی"}
                                    value={category}
                                    setValue={setCategory}
                                    items={[
                                        raikoCustomSelectItemGenerator(
                                            "ALL", "همه"
                                        ),
                                        raikoCustomSelectItemGenerator(
                                            "loans", "وام ها"
                                        ), raikoCustomSelectItemGenerator(
                                            "accounts", "حساب ها"
                                        )
                                    ]}
                                />

                                <RaikoDatePicker
                                    label={"تاریخ شروع"}
                                    date={startDate}
                                    setDate={setStartDate}/>

                                <RaikoDatePicker
                                    label={"تاریخ پایان"}
                                    date={endDate}
                                    setDate={setEndDate}/>


                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>

                        <RaikoCustomTable
                            header={header}
                            data={logs}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            newPage={page}
                            handlePaginationChange={handleChangePagination}
                            emptyListTitle={"هیچ سابقه ی فعالیتی یافت نشد."}
                            rowClicked={handleShowDetail}
                        />


                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    </>
}


const header = [
    {
        id: 'number',
        label: '#',
    }, {
        id: 'type',
        label: 'عملیات',
    }, {
        id: 'category',
        label: 'دسته بندی',
    }, {
        id: 'date',
        label: 'تاریخ',
    }, {
        id: 'username',
        label: 'کاربر',
    },
]